// @ts-nocheck

import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';

import theme from '../../styled-components/dark';

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 50%;

  width: 1.8em;
  height: 1.8em;

  ${({ $atLeastOne }) => css`
    background-color: ${$atLeastOne ? theme.Counter.some.backgroundColor : theme.Counter.none.backgroundColor};
    color: ${$atLeastOne ? theme.Counter.some.color : theme.Counter.none.color};
  `}
`;

type CounterProps = {
  counter: number;
  className?: string;
};

const Counter = ({ counter, className = '' }: CounterProps) => {
  const shouldRender = useMemo(() => counter !== undefined && counter !== null, [counter]);

  if (shouldRender) {
    return (
      <Content className={className} $atLeastOne={counter > 0}>
        {counter}
      </Content>
    );
  }
  return null;
};

export default Counter;
